export const regexUserName = /^[\p{L}\s'-.]+$/u;
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
